module.exports = __webpack_public_path__ + "img/co-pace-how.521d0b5f.png";